APP.DataTable = (/** @lends APP.DataTable */function () {
	'use strict';

	var exports,
		serviceURL,
		currentPage = 1,
		hideCancelledCtn = false,
		totalShow,
		asyncTimer = null,
		refreshTid,
		$body,
		$dataTable,
		$dataTableContent,
		$dataTablePaginator,
		$dataTableTotalSelect,
		$paginatorTPL,
		$dataTableRowTPL,
		$deleteConfirm,
		$billCountTPL,
		$campaignsTPL;

	function init() {
		$body = APP.Performance.getCachedDOM().$body;

		if (!$body.find('[data-datatable]').length) {
			return false;
		}

		initVariables();
		totalShow = $dataTableTotalSelect.val();
		initBindings();
		update();
	}

	function initVariables() {
		$dataTable = $body.find('[data-datatable]');
		$dataTableContent = $dataTable.find('[data-datatable-content]');
		$dataTablePaginator = $dataTable.find('[data-datatable-paginator]');
		$dataTableTotalSelect = $dataTable.find('[data-datatable-total-select]');

		$paginatorTPL = APP.Template.get('paginator');
		$dataTableRowTPL = APP.Template.get('data-table-row');
		$deleteConfirm = APP.Template.get('data-confirm-delete');

		$billCountTPL = APP.Template.get('partial/datatable-billCount');
		$campaignsTPL = APP.Template.get('partial/datatable-campaigns');

		serviceURL = $dataTable.attr('data-datatable');

		hideCancelledCtn = $body.find('[data-change="refresh-ctn-list"]').prop('checked');
	}

	function initBindings() {
		$dataTableTotalSelect.on('change', function () {
			totalShow = $(this).val();
			currentPage = 1;
			update();
		});

		APP.Bind.click({
			'delete-account': function (event, argument) {
				try {
					APP.Overlay.setContent($deleteConfirm(window.parseJSON(argument)));
					APP.Overlay.open();
				} catch (error) {
					if (window.console) {
						console.warn(error);
					}
				}
			},

			'approve-delete': function (event, id) {
				APP.Service.post({id: id}, window.$element('datatable').attr('data-datatable-delete'))
					.done(function () {
						APP.Analytics.trackEvent('Subscription', 'Remove', '');
						update();
						APP.Overlay.close();
						$body.find('[data-remove-subscription-button]').removeClass('button--grey-active');
						window.$element('subscription-wrapper').addClass('subscription-page__box--hide-removes');
						APP.Header.updateCtnList();
					});
			}

		});

		APP.Bind.change({
			'refresh-ctn-list': function (event) {
				event.stopPropagation();
				event.preventDefault();
				window.clearTimeout(refreshTid);
				refreshTid = window.setTimeout(function () {
					hideCancelledCtn = $(event.currentTarget).prop('checked');
					update();
				}, 500);
			}
		});

		APP.Bind.blur({
			'change-nickname': function (event, arg) {
				if ($(event.currentTarget).val() === '') {
					$(event.currentTarget).val($(event.currentTarget).attr('data-original-nickname'));
					return false;
				}

				APP.Service.post({'ctn-or-ca': window.parseJSON(arg).id, nickname: $(event.currentTarget).val()}, window.$element('datatable').attr('data-datatable-edit'))
					.done(function () {
						APP.Analytics.trackEvent('Subscription', 'Rename', '');
						update();
						APP.Header.updateCtnList();
					});
			}

		});

		APP.Bind.focus({
			'nickname-focus': function (event) {
				$(event.currentTarget).val('');
			}

		});
	}

	function getURL() {
		return serviceURL + '/' + totalShow + '/' + currentPage + '?hideCancelledCtn=' + (hideCancelledCtn ? '1' : '0');
	}

	function update(isAsyncUpdate) {
		var url = getURL();

		window.clearTimeout(asyncTimer);
		APP.Service.get({}, url)
			.done(function (response) {

				if (response.data.async !== undefined && response.data.async.wait) {
					asyncUpdate(response.data.async.wait * 1000);
				}

				if (isAsyncUpdate) {
					updateTable(response);
				} else {
					renderTable(response);
				}
			});
	}

	function initPaginatorBindings() {
		$dataTablePaginator.find('a[data-page-id]').on('click', function (e) {
			currentPage = $(this).attr('data-page-id');
			update();
			e.preventDefault();
		});
	}

	function updateTable(data) {
		var i,
			k = 0,
			subscriptions;

		$dataTable.find('.tooltip').tipso('destroy');
		$('.subscription-tooltip').remove();


		for (i = 0; i < data.data.list.length; i++) {
			subscriptions = data.data.list[i].subscriptions;

			for (k = 0; k < subscriptions.length; k++) {
				$dataTable
					.find('[data-table-subscription-module="billCount"][data-table-subscription-id="' + subscriptions[k].id + '"]')
					.html($billCountTPL(subscriptions[k]));

				$dataTable
					.find('[data-table-subscription-module="campaigns"][data-table-subscription-id="' + subscriptions[k].id + '"]')
					.html($campaignsTPL(subscriptions[k]));

			}
		}

		APP.Tooltip.updateWithin($dataTable);

	}

	function asyncUpdate(timeout) {
		asyncTimer = window.setTimeout(function () {
			update(true);
		}, timeout);
	}

	function renderTable(data) {
		$dataTableContent.html($dataTableRowTPL(data));
		$dataTablePaginator.html($paginatorTPL(data));
		APP.Tooltip.updateWithin($dataTableContent);
		initPaginatorBindings();

		if (data.data.list.length === 0) {
			window.$element('subscription-wrapper').removeClass('subscription-page__box--hide-forms');
		}

		initPager(data.data);
		setDeleteButtonVisibility(data.data);
	}

	function initPager(data) {
		var $paginator = $body.find('[data-datatable-paginator]');

		$paginator.find('.paginator__page').addClass('paginator__page--inactive');
		$paginator.find('[data-page-id="1"],[data-page-id="' + data.pages.length + '"],[data-page-id="' + data.current + '"]')
			.removeClass('paginator__page--inactive');
		$paginator.find('[data-page-id="' + (parseInt(data.current, 10) - 1) + '"],[data-page-id="' + (parseInt(data.current, 10) + 1) + '"]')
			.removeClass('paginator__page--inactive');
	}

	function setDeleteButtonVisibility(data) {
		if (data.list.length > 0) {
			$body.find('[data-remove-subscription-button]').attr('style', '');
		} else {
			$body.find('[data-remove-subscription-button]').css('display', 'none');
		}
	}

	function updateAndHideForm(data) {

		if (data && data.hasCancelledCTN) {
			$body.find('[data-cancelled-ctn-wrapper]').addClass('block').removeClass('block--display-none');
		} else {
			$body.find('[data-cancelled-ctn-wrapper]').addClass('block--display-none').removeClass('block');
		}

		APP.Overlay.openWithTpl('datatable-success-save');
		window.$element('subscription-wrapper').addClass('subscription-page__box--hide-forms');
		$body.find('[name="ctn-or-ca"],[name="pass"]').val('');
		update();
		APP.Header.updateCtnList();
	}

	function openamCtnSmsAddForm(data) {
		var elementPhoneNumber = $body.find('[data-ctn-sms-phone-number]'),
			elementConfirmationCode = $body.find('[data-ctn-sms-confirmation-code]');

		if (data && data.success && data.stage === 'YettelSms4') {
			elementPhoneNumber.addClass('block--display-none');
			elementConfirmationCode.removeClass('block--display-none');
		} else if (data && data.success && data.stage === 'CodeValidated') {
			elementPhoneNumber.removeClass('block--display-none');
			elementConfirmationCode.addClass('block--display-none');
			APP.Overlay.openWithTpl('datatable-success-add-ctn');
			window.$element('subscription-wrapper').addClass('subscription-page__box--hide-forms');
			$body.find('[name="phoneNumber"],[name="confirmationCode"]').val('');
			APP.Header.updateCtnList();
		}
		if (data && !data.success) {
			elementPhoneNumber.removeClass('block--display-none');
			elementConfirmationCode.addClass('block--display-none');
		}
		update();
	}

	function resetCtnSmsForm(){
		var elementPhoneNumber = $body.find('[data-ctn-sms-phone-number]'),
			elementConfirmationCode = $body.find('[data-ctn-sms-confirmation-code]');

		$body.find('[name="phoneNumber"],[name="confirmationCode"]').val('');
		elementPhoneNumber.removeClass('block--display-none');
		elementConfirmationCode.addClass('block--display-none');
		update();
	}

	exports = {
		init: init,
		update: update,
		updateAndHideForm: updateAndHideForm,
		openamCtnSmsAddForm: openamCtnSmsAddForm,
		resetCtnSmsForm: resetCtnSmsForm
	};

	/* test-code */
	/* eslint no-underscore-dangle: 0 */
	exports.__testonly__ = {};
	/* end-test-code */

	return exports;

}());
